import React, { Component } from "react"
import PropTypes from "prop-types"

import {
    EventCalendar,
    NoteCalendar
} from "search-new/containers/Visualization/Calendar/Calendars"

const CalendarWrapper = (props) => {
    const possibleCalendars = [EventCalendar, NoteCalendar]

    const CurrentCal = possibleCalendars.find(
        cal => cal.defaultProps.quorumDataType === props.quorumDataType
    )

    return Boolean(CurrentCal) && <CurrentCal {...props} />
}

CalendarWrapper.propTypes = {
    uniqueFlvId: PropTypes.string.isRequired,
    quorumDataType: PropTypes.number.isRequired,
    resource: PropTypes.object.isRequired,
}

export default CalendarWrapper
